module.exports = __webpack_public_path__ + "static/img/8.2433989.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/sp/8.png
// module id = vPj2
// module chunks = 0